// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as CrmRepoManager from "../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as Actions$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/actions/Actions.bs.js";
import * as OrderRepoManager from "../../../../../../../library/data-source/order/repo/OrderRepoManager.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as TicketDashboardRepoManager from "../../../../../ticket-dashboard/app/tickets/repo/TicketDashboardRepoManager.bs.js";
import * as IncentiveDashboardRepoManager from "../../../../app/incentive/repo/IncentiveDashboardRepoManager.bs.js";

function reducer(action, state) {
  switch (action.TAG | 0) {
    case /* DriverInfo */0 :
        return {
                driverInfo: Actions$Catalyst.mapLoadableToAction(action._0),
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* Orders */1 :
        return {
                driverInfo: state.driverInfo,
                orders: Actions$Catalyst.mapLoadableToAction(action._0),
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* Tickets */2 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: Actions$Catalyst.mapLoadableToAction(action._0),
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* Incentives */3 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: Actions$Catalyst.mapLoadableToAction(action._0),
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* SuspensionInfo */4 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: Actions$Catalyst.mapLoadableToAction(action._0),
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* WeeklyEarnings */5 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: Actions$Catalyst.mapLoadableToAction(action._0),
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* WalletInfo */6 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: Actions$Catalyst.mapLoadableToAction(action._0),
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* TerminationInfo */7 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: Actions$Catalyst.mapLoadableToAction(action._0),
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* PartnerDocument */8 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: Actions$Catalyst.mapLoadableToAction(action._0),
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* PartnerOnboardingData */9 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: Actions$Catalyst.mapLoadableToAction(action._0),
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* PartnerWaitlistData */10 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: Actions$Catalyst.mapLoadableToAction(action._0),
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* HelperServiceabililty */11 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: Actions$Catalyst.mapLoadableToAction(action._0),
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* HelperLabourServiceabililty */12 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: Actions$Catalyst.mapLoadableToAction(action._0),
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* OutStationServiceability */13 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: Actions$Catalyst.mapLoadableToAction(action._0),
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* RentalServiceability */14 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: Actions$Catalyst.mapLoadableToAction(action._0),
                premiumPartnerReport: state.premiumPartnerReport
              };
    case /* PremiumPartnerReport */15 :
        return {
                driverInfo: state.driverInfo,
                orders: state.orders,
                tickets: state.tickets,
                incentives: state.incentives,
                suspensionInfo: state.suspensionInfo,
                weeklyEarnings: state.weeklyEarnings,
                walletInfo: state.walletInfo,
                terminationInfo: state.terminationInfo,
                partnerDocument: state.partnerDocument,
                partnerOnboardingData: state.partnerOnboardingData,
                partnerWaitlistData: state.partnerWaitlistData,
                helperServiceabilityInfo: state.helperServiceabilityInfo,
                helperLabourServiceability: state.helperLabourServiceability,
                outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                rentalServiceabilityInfo: state.rentalServiceabilityInfo,
                premiumPartnerReport: Actions$Catalyst.mapLoadableToAction(action._0)
              };
    
  }
}

function loadDriver(msisdn, dispatch, country) {
  var RepoInstance = CrmRepoManager.getDriverRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchDriver, msisdn, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* DriverInfo */0,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* DriverInfo */0,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadOrders(msisdn, dispatch, country) {
  var RepoInstance = OrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchOrders_old, msisdn, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* Orders */1,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* Orders */1,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadTickets(msisdn, dispatch, country) {
  var RepoInstance = TicketDashboardRepoManager.getTicketsRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchTickets, {
                            crn: undefined,
                            case_number: undefined,
                            caller_number: undefined,
                            msisdn: msisdn,
                            start_datetime: undefined,
                            end_datetime: undefined,
                            ticket_status: /* Open */0,
                            geo_region: undefined,
                            raised_by: /* Partner */1
                          }, undefined, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* Tickets */2,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data.tickets
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* Tickets */2,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadIncentives(msisdn, dispatch, country) {
  var RepoInstance = IncentiveDashboardRepoManager.getIncentivesRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchIncentives, msisdn, "0", country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* Incentives */3,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* Incentives */3,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadSuspensionInfo(driverUuid, dispatch, country) {
  var RepoInstance = CrmRepoManager.getSuspensionRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchSuspensionInfo, driverUuid, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* SuspensionInfo */4,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SuspensionInfo */4,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function refreshSuspensionInfo(driverUuid, dispatch, country) {
  Curry._1(dispatch, {
        TAG: /* SuspensionInfo */4,
        _0: {
          TAG: /* Load */0,
          _0: undefined
        }
      });
  return loadSuspensionInfo(driverUuid, dispatch, country);
}

function loadPartnerEarningsData(msisdn, dispatch, country) {
  var RepoInstance = CrmRepoManager.getDriverEarningsRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchDriverEarningSummaries, msisdn, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* WeeklyEarnings */5,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* WeeklyEarnings */5,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadWalletData(msisdn, dispatch, country) {
  var RepoInstance = CrmRepoManager.getWalletRepo(undefined);
  var walletReportRequest_tillDate = new Date();
  var walletReportRequest = {
    msisdn: msisdn,
    tillDate: walletReportRequest_tillDate,
    transactionStatus: undefined,
    offset: undefined
  };
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchWallet, walletReportRequest, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* WalletInfo */6,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* WalletInfo */6,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadTerminationData(msisdn, dispatch, country) {
  var RepoInstance = CrmRepoManager.getTerminationRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchTerminationInfo, msisdn, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* TerminationInfo */7,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* TerminationInfo */7,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function refreshTerminationData(msisdn, dispatch, country) {
  Curry._1(dispatch, {
        TAG: /* TerminationInfo */7,
        _0: {
          TAG: /* Load */0,
          _0: undefined
        }
      });
  return loadTerminationData(msisdn, dispatch, country);
}

function loadPartnerDocumentsData(uuid, dispatch, country) {
  var RepoInstance = CrmRepoManager.getDriverRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchPartnerDocuments, uuid, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* PartnerDocument */8,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* PartnerDocument */8,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadPartnerOnboardingData(msisdn, dispatch, country) {
  var RepoInstance = CrmRepoManager.getDriverRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchPartnerOnboardingInfo, msisdn, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* PartnerOnboardingData */9,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* PartnerOnboardingData */9,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadHelperServiceabilityInfo(msisdn, dispatch, country) {
  var RepoInstance = CrmRepoManager.getServiceabilityRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.getHelperServiceabilityInfo, msisdn, undefined, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* HelperServiceabililty */11,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* HelperServiceabililty */11,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadOutStationServiceabilityInfo(msisdn, dispatch, country) {
  var RepoInstance = CrmRepoManager.getServiceabilityRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.getOutStationServiceabilityInfo, msisdn, undefined, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* OutStationServiceability */13,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* OutStationServiceability */13,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadRentalServiceabilityInfo(msisdn, dispatch, country) {
  var RepoInstance = CrmRepoManager.getServiceabilityRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.getRentalServiceabilityInfo, msisdn, undefined, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* RentalServiceability */14,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* RentalServiceability */14,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadPartnerWaitlistData(msisdn, dispatch, country) {
  var RepoInstance = CrmRepoManager.getDriverRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchPartnerWaitlistInfo, msisdn, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* PartnerWaitlistData */10,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* PartnerWaitlistData */10,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadPremiumPartnerReports(msisdn, dispatch, country) {
  var RepoInstance = CrmRepoManager.getPremiumPartnerReportRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchSubscriptionReport, msisdn, undefined, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* PremiumPartnerReport */15,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* PremiumPartnerReport */15,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function loadHelperLabourServiceabilityInfo(msisdn, dispatch, country) {
  var RepoInstance = CrmRepoManager.getServiceabilityRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchHelperLabourServiceability, msisdn, undefined, country);
              }), (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* HelperLabourServiceabililty */12,
                            _0: {
                              TAG: /* OnLoaded */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* HelperLabourServiceabililty */12,
                            _0: {
                              TAG: /* LoadErrorView */2,
                              _0: error
                            }
                          });
              }));
}

function fetchDataForCalcPartnerStatus(msisdn, dispatch, country) {
  loadTerminationData(msisdn, dispatch, country);
  loadPartnerOnboardingData(msisdn, dispatch, country);
  return loadPartnerWaitlistData(msisdn, dispatch, country);
}

var initialState = {
  driverInfo: {
    TAG: /* Loading */0,
    _0: undefined
  },
  orders: {
    TAG: /* Loading */0,
    _0: undefined
  },
  tickets: {
    TAG: /* Loading */0,
    _0: undefined
  },
  incentives: {
    TAG: /* Loading */0,
    _0: undefined
  },
  suspensionInfo: {
    TAG: /* Loading */0,
    _0: undefined
  },
  weeklyEarnings: {
    TAG: /* Loading */0,
    _0: undefined
  },
  walletInfo: {
    TAG: /* Loading */0,
    _0: undefined
  },
  terminationInfo: {
    TAG: /* Loading */0,
    _0: undefined
  },
  partnerDocument: {
    TAG: /* Loading */0,
    _0: undefined
  },
  partnerOnboardingData: {
    TAG: /* Loading */0,
    _0: undefined
  },
  partnerWaitlistData: {
    TAG: /* Loading */0,
    _0: undefined
  },
  helperServiceabilityInfo: {
    TAG: /* Loading */0,
    _0: undefined
  },
  helperLabourServiceability: {
    TAG: /* Loading */0,
    _0: undefined
  },
  outStationServiceabilityInfo: {
    TAG: /* Loading */0,
    _0: undefined
  },
  rentalServiceabilityInfo: {
    TAG: /* Loading */0,
    _0: undefined
  },
  premiumPartnerReport: {
    TAG: /* Loading */0,
    _0: undefined
  }
};

export {
  reducer ,
  initialState ,
  loadDriver ,
  loadOrders ,
  loadTickets ,
  loadIncentives ,
  loadSuspensionInfo ,
  refreshSuspensionInfo ,
  loadPartnerEarningsData ,
  loadWalletData ,
  loadTerminationData ,
  refreshTerminationData ,
  loadPartnerDocumentsData ,
  loadPartnerOnboardingData ,
  loadHelperServiceabilityInfo ,
  loadOutStationServiceabilityInfo ,
  loadRentalServiceabilityInfo ,
  loadPartnerWaitlistData ,
  loadPremiumPartnerReports ,
  loadHelperLabourServiceabilityInfo ,
  fetchDataForCalcPartnerStatus ,
  
}
/* CrmRepoManager Not a pure module */
